import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import LinkShareOptions from "@/components/LinkShareOptions";

export const APP_URL = "https://mango-notes.com";
const PITCH = "I've been using Mango Notes — it works offline, syncs if you back up, and has drawings & voice memos.";

export default function ShareAppDialog({ open, onOpenChange }) {
  const mailto = `mailto:?subject=${encodeURIComponent("Try Mango Notes — a tactile notes app")}&body=${encodeURIComponent(`${PITCH}\n\nTry it here:\n${APP_URL}`)}`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="share-app-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Share Mango Notes</DialogTitle>
          <DialogDescription>Send a friend the link, or let them scan the QR code.</DialogDescription>
        </DialogHeader>
        <LinkShareOptions url={APP_URL} title="Mango Notes" testId="share-app" />
        <Button variant="outline" className="w-full rounded-full" asChild>
          <a href={mailto} data-testid="share-app-email"><Mail className="h-4 w-4 mr-2" />Email an invite</a>
        </Button>
      </DialogContent>
    </Dialog>
  );
}
